export default {
    notchedOutline: {
        borderColor: '#d6d6d6'
    },

    input: {
        padding: '12px 15px'
    }
};
